import {
    DOUBLE_WHEEL_MASTERGROUP, DOUBLE_WHEEL_PRIZE_PREFIX, MATCH_THREE_MASTERGROUP, MATCH_THREE_PRIZE_PREFIX,
    PENALTY_SHOOTOUT_MASTERGROUP, PENALTY_SHOOTOUT_PRIZE_PREFIX, SINGLE_WHEEL_MASTERGROUP,
    SINGLE_WHEEL_PRIZE_PREFIX, STEP_CLIMB_MASTERGROUP, STEP_CLIMB_PRIZE_PREFIX, DAILY_SHOP_WHEEL_MASTERGROUP,
    DAILY_SHOP_WHEEL_PRIZE_PREFIX, DAILY_SHOP_WHEEL_BACKUP_PRIZE_PREFIX
} from "Setup/config";

export const PREFIXES = {
    DAILY_DEAL: "DD_",
    FREE_SPINS_GAME: "FS_",
    PICK_YOUR_BONUS: "PYB_",
    SPIN_THE_WHEEL: "WHEEL_",
    MATCH_THREE: MATCH_THREE_MASTERGROUP,
    DOUBLE_WHEEL: DOUBLE_WHEEL_MASTERGROUP,
    SINGLE_WHEEL: SINGLE_WHEEL_MASTERGROUP,
    PENALTY_SHOOTOUT: PENALTY_SHOOTOUT_MASTERGROUP,
    STEP_CLIMB: STEP_CLIMB_MASTERGROUP,
    DAILY_SHOP_WHEEL: DAILY_SHOP_WHEEL_MASTERGROUP,
};

const MASTERGROUPS = {
    DAILY_DEAL: `${PREFIXES.DAILY_DEAL}MASTERGROUP`,
    FREE_SPINS_GAME: `${PREFIXES.FREE_SPINS_GAME}MASTERGROUP`,
    PICK_YOUR_BONUS: `${PREFIXES.PICK_YOUR_BONUS}MASTERGROUP`,
    SPIN_THE_WHEEL: `${PREFIXES.SPIN_THE_WHEEL}MASTERGROUP_ACCESS_GRANTED`,
    GAMBIT_MATCH_THREE_GAME: `${PREFIXES.MATCH_THREE}MASTERGROUP`,
    GAMBIT_GAME_DOUBLE_WHEEL: `${PREFIXES.DOUBLE_WHEEL}MASTERGROUP`,
    GAMBIT_GAME_SINGLE_WHEEL: `${PREFIXES.SINGLE_WHEEL}MASTERGROUP`,
    GAMBIT_GAME_PENALTY_SHOOTOUT: `${PREFIXES.PENALTY_SHOOTOUT}MASTERGROUP`,
    GAMBIT_GAME_STEP_CLIMB: `${PREFIXES.STEP_CLIMB}MASTERGROUP`,
    GAMBIT_GAME_DAILY_SHOP_WHEEL: `${PREFIXES.DAILY_SHOP_WHEEL}MASTERGROUP`,
};

export const EXCLUDER_PROMOCODES = {
    DAILY_DEAL: `${PREFIXES.DAILY_DEAL}EXCLUDER`,
    FREE_SPINS_GAME: `${PREFIXES.FREE_SPINS_GAME}EXCLUDER`,
    SPIN_WHE_WHEEL: "WHEELCLAIMED_V2",
};

export const PROMO_PREFIXES = {
    NOTIFICATION: "NOTIFICATION_",

    LOBBY_BANNER: "LOBBY_BANNER",
    LOBBY_BANNER_ADDITIONAL: "LOBBY_BANNER_ADDITIONAL",

    REWARDS: "REWARDS_LEVEL_",
    REWARDS_INFO: "REWARDS_INFO_",

    // Exact internalNames rather than prefixes: the Content bonuses that fill the
    // parts of the shop page that are not purchasable items. Each is optional —
    // without its bonus, that piece of the page does not render.
    SHOP_HOW_TO_PLAY: "SHOP_CONTENT_HOW_TO_PLAY",
    SHOP_BANNER: "SHOP_CONTENT_BANNER",

    DD_MASTERGROUP: MASTERGROUPS.DAILY_DEAL,
    DD_PRIZE: `${PREFIXES.DAILY_DEAL}PRIZE`,

    FREE_SPINS_GAME_MASTERGROUP: MASTERGROUPS.FREE_SPINS_GAME,
    FREE_SPINS_GAME_PREFIX: `${PREFIXES.FREE_SPINS_GAME}PRIZE_`,

    PYB_MASTERGROUP: MASTERGROUPS.PICK_YOUR_BONUS,
    PYB_OPTION: `${PREFIXES.PICK_YOUR_BONUS}OPTION_`,
    PYB_OPTION_ACTUAL: "_ACTUALOFFER",

    SPIN_THE_WHEEL_MASTERGROUP: MASTERGROUPS.SPIN_THE_WHEEL,
    SPIN_THE_WHEEL_SPUN: `${PREFIXES.SPIN_THE_WHEEL}SPUN_V2`,
    SPIN_THE_WHEEL_PRIZE: `${PREFIXES.SPIN_THE_WHEEL}PRIZE_`,
    SPIN_THE_WHEEL_PRIZE_CLAIMED: `${PREFIXES.SPIN_THE_WHEEL}CLAIMED_V2`,

    GAMBIT_MATCH_THREE_GAME_MASTERGROUP: MASTERGROUPS.GAMBIT_MATCH_THREE_GAME,
    GAMBIT_MATCH_THREE_GAME_PRIZE: `${PREFIXES.MATCH_THREE}${MATCH_THREE_PRIZE_PREFIX}`,

    GAMBIT_DOUBLE_WHEEL_GAME_MASTERGROUP: MASTERGROUPS.GAMBIT_GAME_DOUBLE_WHEEL,
    GAMBIT_DOUBLE_WHEEL_GAME_PRIZE: `${PREFIXES.DOUBLE_WHEEL}${DOUBLE_WHEEL_PRIZE_PREFIX}`,

    GAMBIT_SINGLE_WHEEL_GAME_MASTERGROUP: MASTERGROUPS.GAMBIT_GAME_SINGLE_WHEEL,
    GAMBIT_SINGLE_WHEEL_GAME_PRIZE: `${PREFIXES.SINGLE_WHEEL}${SINGLE_WHEEL_PRIZE_PREFIX}`,

    GAMBIT_PENALTY_SHOOTOUT_GAME_MASTERGROUP: MASTERGROUPS.GAMBIT_GAME_PENALTY_SHOOTOUT,
    GAMBIT_PENALTY_SHOOTOUT_GAME_PRIZE: `${PREFIXES.PENALTY_SHOOTOUT}${PENALTY_SHOOTOUT_PRIZE_PREFIX}`,

    GAMBIT_STEP_CLIMB_GAME_MASTERGROUP: MASTERGROUPS.GAMBIT_GAME_STEP_CLIMB,
    GAMBIT_STEP_CLIMB_GAME_PRIZE: `${PREFIXES.STEP_CLIMB}${STEP_CLIMB_PRIZE_PREFIX}`,

    GAMBIT_DAILY_SHOP_WHEEL_GAME_MASTERGROUP: MASTERGROUPS.GAMBIT_GAME_DAILY_SHOP_WHEEL,
    GAMBIT_DAILY_SHOP_WHEEL_GAME_PRIZE: `${PREFIXES.DAILY_SHOP_WHEEL}${DAILY_SHOP_WHEEL_PRIZE_PREFIX}`,
    GAMBIT_DAILY_SHOP_WHEEL_GAME_BACKUP_PRIZE: `${PREFIXES.DAILY_SHOP_WHEEL}${DAILY_SHOP_WHEEL_BACKUP_PRIZE_PREFIX}`,
    // The Cashback on Total Stake bonus whose stake has to be met before the wheel spins.
    GAMBIT_DAILY_SHOP_WHEEL_GAME_WAGERING: `${PREFIXES.DAILY_SHOP_WHEEL}WAGERING`
};
